const storagePrefix = 'ailtra_bot_';

const storage = {
    getAccessToken: () => {
        return (window.localStorage.getItem(`${storagePrefix}accessToken`)) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}accessToken`)) : "";
    },
    setAccessToken: (token) => {
        window.localStorage.setItem(`${storagePrefix}accessToken`, JSON.stringify(token));
    },
    clearAccessToken: () => {
        window.localStorage.removeItem(`${storagePrefix}accessToken`);
    },
    getRefreshAccessToken: () => {
        return (window.localStorage.getItem(`${storagePrefix}refreshAccessToken`)) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}refreshAccessToken`)) : "";
    },
    setRefreshAccessToken: (token) => {
        window.localStorage.setItem(`${storagePrefix}refreshAccessToken`, JSON.stringify(token));
    },
    clearRefreshAccessToken: () => {
        window.localStorage.removeItem(`${storagePrefix}refreshAccessToken`);
    },
    getIdToken: () => {
        return (window.localStorage.getItem(`${storagePrefix}idToken`)) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}idToken`)) : "";
    },
    setIdToken: (token) => {
        window.localStorage.setItem(`${storagePrefix}idToken`, JSON.stringify(token));
    },
    clearIdToken: () => {
        window.localStorage.removeItem(`${storagePrefix}idToken`);
    },
    getUserName: () => {
        return (window.localStorage.getItem(`${storagePrefix}userName`)) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}userName`)) : "";
    },
    setUserName: (token) => {
        window.localStorage.setItem(`${storagePrefix}userName`, JSON.stringify(token));
    },
    clearUserName: () => {
        window.localStorage.removeItem(`${storagePrefix}userName`);
    },
    getUserEmail: () => {
        return (window.localStorage.getItem(`${storagePrefix}userEmail`)) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}userEmail`)) : "";
    },
    setUserEmail: (token) => {
        window.localStorage.setItem(`${storagePrefix}userEmail`, JSON.stringify(token));
    },
    clearUserEmail: () => {
        window.localStorage.removeItem(`${storagePrefix}userEmail`);
    },
    getUserProfilePicture: () => {
        return (window.localStorage.getItem(`${storagePrefix}userProfilePicture`)) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}userProfilePicture`)) : "";
    },
    setUserProfilePicture: (token) => {
        window.localStorage.setItem(`${storagePrefix}userProfilePicture`, JSON.stringify(token));
    },
    clearUserProfilePicture: () => {
        window.localStorage.removeItem(`${storagePrefix}userProfilePicture`);
    },
    isAuthorized: () => {
        const token = storage.getToken();
        return !!token;
    },
    // Retrieves and parses a value from localStorage based on the given dynamic propertyName key.
    getLocalProperty: (propertyName) => {
        return ((propertyName || "") !== "") ? JSON.parse(window.localStorage.getItem(`${storagePrefix}${propertyName}`)) : "";
    },
    // Stores a value (e.g., boolean, number, or object) under a dynamic propertyName key in localStorage.
    setLocalProperty: (propertyName, value) => {
        window.localStorage.setItem(`${storagePrefix}${propertyName}`, JSON.stringify(value));
    },
    // Removes a specific propertyName key and its value from localStorage.
    clearLocalProperty: (propertyName) => {
        window.localStorage.removeItem(`${storagePrefix}${propertyName}`);
    }
};

export {
    storage
};